import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Kota from "../component/dumy/dataKota";
import { useTranslation } from "react-i18next";
import { useCookies } from "react-cookie";
import Swal from "sweetalert2";
import axios from "axios";
import $ from "jquery";

const Header = () => {
  const location = useLocation();
  const { i18n } = useTranslation();
  const [cookies, setCookie] = useCookies(["i18next"]);

  const [activeMenu, setActiveMenu] = useState(location.pathname);
  const [dataKota, setDataKota] = useState([]);
  const [menux, setMenu] = useState([]);
  const [loading, setLoading] = useState(true);
  const [locationsx, setLocation] = useState();

  const handleMenuClick = (menu) => {
    if (menu !== "#" && menu !== "#t" && menu !== "") {
      setActiveMenu(menu);
    }
  };

  const convertToSlug = (title) => {
    return title
      ?.toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  };

  // Sinkronisasi bahasa dari cookie ke i18n
  useEffect(() => {
    if (!cookies.i18next) {
      setCookie("i18next", "id", { path: "/" });
      i18n.changeLanguage("id");
    } else {
      i18n.changeLanguage(cookies.i18next);
    }
  }, [cookies.i18next, i18n, setCookie]);

  // Fetch Menu
  useEffect(() => {
    const fetchMenu = async () => {
      setLoading(true);
      try {
        const url = process.env.REACT_APP_API_URL;
        const endpoint = process.env.REACT_APP_API_MENU_ALL;
        const response = await axios.get(`${url}${endpoint}`);
        setMenu(response.data);
      } catch (err) {
        Swal.fire({ icon: "error", title: "Oops...", text: err.message });
      } finally {
        setLoading(false);
      }
    };
    fetchMenu();
  }, []);

  // Update URL state
  useEffect(() => {
    if (Kota) setDataKota(Kota);
    const locati = location.pathname.split("/");
    const foundItem = dataKota.find((kneks) => convertToSlug(kneks.title) === locati[2]);
    setLocation(foundItem);
    setActiveMenu(location.pathname);
  }, [location, dataKota]);

  const splita = location.pathname.split("/");
  const isKdeksPage = locationsx && splita[2] === convertToSlug(locationsx.title);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setCookie("i18next", lng, { path: "/" });
  };

  // jQuery Mobile Nav Integration
  useEffect(() => {
    const menuEl = $(".main-menu .navigation ul")[0];
    if (menuEl) {
      const menu_content = menuEl.outerHTML;
      $(".mobile-nav-container").html(menu_content);

      const $mobileNav = $(".mobile-nav-container");

      $mobileNav.find(".main-menu-list li.has-dropdown > a").append(
        '<button class="dropdown-btn"><i class="fa-solid fa-chevron-right"></i></button>'
      );

      // Gunakan .off('click') untuk membersihkan listener lama sebelum pasang baru
      $mobileNav.find(".main-menu-list li.has-dropdown > a button.dropdown-btn")
        .off("click")
        .on("click", function (e) {
          e.preventDefault();
          $(this).toggleClass("expanded");
          $(this).parents("a").siblings("ul").slideToggle();
        });

      $mobileNav.find(".lang-btn-id").off("click").on("click", function (e) {
        e.preventDefault();
        changeLanguage("id");
      });
      $mobileNav.find(".lang-btn-en").off("click").on("click", function (e) {
        e.preventDefault();
        changeLanguage("en");
      });
    }
  }, [menux, i18n.language]);

  return (
    <>
      <div id="pre-loader">
        <div id="loader-logo"></div>
        <div id="loader-circle"></div>
        <div className="loader-section section-left"></div>
        <div className="loader-section section-right"></div>
      </div>

      <header className="header">
        <div className="main-menu sticky-header">
          <div className="main-menu-inner">
            <div className="main-menu-left">
              <div className={isKdeksPage ? "" : "main-menu-logo"}>
                {!isKdeksPage && (
                  <>
                    <a href="/"><img src="/assets/image/logo1.png" alt="logo" className="logo-large" /></a>
                    <span className="separator"></span>
                    <a href="/tentang-ekonomi-syariah"><img src="/assets/image/logo2.png" alt="logo" className="logo-small" /></a>
                  </>
                )}
              </div>

              {!isKdeksPage && (
                <div className="navigation">
                  <ul className="main-menu-list list-unstyled">
                    {loading ? (
                      Array(5).fill(0).map((_, index) => (
                        <li key={index} className="skeleton-m-item">
                          <div className="skeleton-m-link"><div className="skeleton-m-text"></div></div>
                        </li>
                      ))
                    ) : Array.isArray(menux) && menux.length > 0 ? (
                      menux.map((item, index) => (
                        <li
                          key={index}
                          className={`${item.menu_sub.length > 0 ? "has-dropdown" : ""} 
                          ${(item.menu_link !== "#" && item.menu_link !== "#t" && activeMenu === item.menu_link) ||
                              (item.menu_sub.length > 0 && item.menu_sub.some((sub) => sub.submenu_link === activeMenu)) ? "active" : ""}`}
                        >
                          <a onClick={() => handleMenuClick(item.menu_link)} href={item.menu_link}>
                            {i18n.language === "en" ? item.menu_name_en : item.menu_name}
                          </a>
                          {item.menu_sub.length > 0 && (
                            <ul className="list-unstyled">
                              {item.menu_sub.map((detail, dIdx) => (
                                <li key={dIdx}>
                                  <a href={detail.submenu_link}>
                                    {i18n.language === "en" ? detail.submenu_name_en : detail.submenu_name}
                                  </a>
                                </li>
                              ))}
                            </ul>
                          )}
                        </li>
                      ))
                    ) : (
                      <li><span>No menu found</span></li>
                    )}

                    {/* Mobile Lang Button */}
                    <li className="d-xxl-none" style={{ marginTop: '10px', padding: '15px 20px', borderTop: '1px solid #ddd' }}>
                      <div className="d-flex justify-content-center align-items-center">
                        <button className={`btn btn-sm mx-1 lang-btn-id ${i18n.language === "id" ? "btn-primary" : "btn-outline-primary"}`}>ID</button>
                        <button className={`btn btn-sm mx-1 lang-btn-en ${i18n.language === "en" ? "btn-primary" : "btn-outline-primary"}`}>EN</button>
                      </div>
                    </li>
                  </ul>
                </div>
              )}
            </div>

            <div className="main-menu-right d-flex align-items-center pr-3">
              <div className="topNav-right d-none d-xxl-block">
                <ul className="d-flex m-0 p-0" style={{ listStyle: 'none' }}>
                  <li onClick={() => changeLanguage("id")} className={i18n.language === "id" ? "text-primary bg-white shadow-sm" : ""} style={{ padding: "8px 15px", margin: "0 5px", cursor: "pointer", borderRadius: "8px", fontSize: "16px", fontWeight: "600" }}>ID</li>
                  <li onClick={() => changeLanguage("en")} className={i18n.language === "en" ? "text-primary bg-white shadow-sm" : ""} style={{ padding: "8px 15px", margin: "0 5px", cursor: "pointer", borderRadius: "8px", fontSize: "16px", fontWeight: "600" }}>EN</li>
                </ul>
              </div>
              <div className="mobile-menu-button mobile-nav-toggler m-0 d-xxl-none ml-3">
                <span></span><span></span><span></span>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;